import React from 'react'
import ReactDOM from 'react-dom'
import { BsyUtils } from '../../utils/Utils'

const BsyBubble = props =>
    new Promise((fulfill) => { // 此处参数需用圆括号，否则 eslint 报错
        let holder
        if (document.getElementsByClassName("BsyAlertMenu").length > 0) {
            document.getElementsByClassName("BsyAlertMenu")[0].remove();
        }
        let rootTokenClass = 'rootTokenCls' + (new Date()).getTime()
        holder = document.createElement('div');
        holder.classList.add("BsyAlertMenu");
        holder.classList.add(rootTokenClass);

        const target = props.target.target || props.target;
        const { top, left } = BsyUtils.elemoffset(target);


        let css = {};
        let leftoffset = 10;
        if(props.position === "right"){
          leftoffset = left;
        }else{
          leftoffset = left - props.width + target.offsetWidth;
        }
        if(props.height > (document.documentElement.clientHeight - top - target.offsetHeight - 10)) {
            if(leftoffset < 10 ) {
                leftoffset = 10
            }
            css = {
                left: leftoffset +( props.leftOffset || 0)+ 'px',
                width: props.width + 'px',
                top: '0'
            };
        } else {
            if(leftoffset < 10 ) {
                leftoffset = 10
            }
            css = {
                left: leftoffset +( props.leftOffset || 0) + 'px',
                width: props.width + 'px',
                top: top + target.offsetHeight + 2 + 'px'
            }
        }

        // let css = props.height > (document.documentElement.clientHeight - top - target.offsetHeight - 10) ? {
        //     left: left - props.width + target.offsetWidth + 'px',
        //     width: props.width + 'px',
        //     bottom: document.documentElement.clientHeight - top + 2 + 'px'
        // } : {
        //     left: left - props.width + target.offsetWidth + 'px',
        //     width: props.width + 'px',
        //     top: top + target.offsetHeight + 2 + 'px'
        // }

        holder.style.zIndex = window.FX.STATIC.zIndex++;
        holder.style.left = css.left;
        holder.style.width = css.width;
        holder.style.height = props.height;
        holder.style.bottom = css.bottom ? css.bottom : "auto";
        holder.style.top = css.top ? css.top : "auto";
        window.mode && holder.classList.add(window.mode);
        if (props.renderEl) {
            props.renderEl.appendChild(holder)
        } else {
            document.body.appendChild(holder)
        }

        let holderTo = document.createElement('div');
        holderTo.classList.add("alertMenuContent");
        holder.onclick = (event) => {
            event.stopPropagation()
        }
        holder.appendChild(holderTo)

        // let timer = setTimeout(()=>{
        //     holder.removeChild(holderTo)
        //     ReactDOM.unmountComponentAtNode(holderTo)
        //     if(document.getElementsByClassName("alertImgCodeContent").length<=0){
        //         document.body.removeChild(holder)
        //         ReactDOM.unmountComponentAtNode(holder)
        //     }
        //     clearInterval(timer)
        // },3000)

        // document.addEventListener()

        let CleanRootNode = (e) => {
            // 当界面被点击时自动清理元素
            // e 为null，组件自己清理自己 
            // 无法找到父级元素 rootTokenClass 说明点击了其他任意位置
            if (!e || !BsyUtils.closestClass(e.target, rootTokenClass)) {
                holder.removeChild(holderTo)
                ReactDOM.unmountComponentAtNode(holderTo)
                holder.remove();
                document.removeEventListener('mouseup', CleanRootNode, false);
                props.onClose && props.onClose(e);
            }
        }

        let CleanRootNode1 = (e) => {
            // 当界面被点击时自动清理元素
            // e 为null，组件自己清理自己 
            // 无法找到父级元素 rootTokenClass 说明点击了其他任意位置
            if (!e || !BsyUtils.closestClass(e.target, rootTokenClass)) {
                holder.removeChild(holderTo)
                ReactDOM.unmountComponentAtNode(holderTo)
                holder.remove();
                document.removeEventListener('mouseup', CleanRootNode, false);
            }
        }

        document.addEventListener('mouseup', CleanRootNode, false);

        if (document.getElementsByClassName("alertMenuContent").length > 1) {
            holder.removeChild(holderTo)
            ReactDOM.unmountComponentAtNode(holderTo)
            // clearInterval(timer)
        }
  
        const newProps = { ...props, target: holderTo }
        newProps.onRemoveRoot = (cd) => {
            //自动清理
            CleanRootNode1();
            cd && cd();
        }
        props.getContext && props.getContext(newProps);
        ReactDOM.render(
            <>
                {
                    props.onContentCreate ? props.onContentCreate() : <></>
                }
            </>
            // <AlertList
            //     {...newProps}
            // />
            ,
            holderTo
        )
    }).catch(res => {
        console.error('BsyBubble',res);
    })

export default BsyBubble